import { render, staticRenderFns } from "./DeactivateAudit.vue?vue&type=template&id=6a547f1b&scoped=true&"
import script from "./DeactivateAudit.vue?vue&type=script&lang=ts&"
export * from "./DeactivateAudit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a547f1b",
  null
  
)

export default component.exports